<script>
export default{
    methods: {
    formatCurrency(amount, currency = 'SYP') {
      const formatter = new Intl.NumberFormat("ar-sy", {
        style: "decimal",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
      const formattedAmount = formatter.format(amount);
      
      // Add currency symbol
      const currencySymbol = currency === 'USD' ? '$' : 'ل.س';
      return `${formattedAmount} ${currencySymbol}`;
    },
}
}
</script>